import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import {
  getIsWebview,
  getIsHotelOnly,
  getCurrencyCode,
  getActivateCashbackForPartner,
  getCashbackLabel,
  getCashbackTooltip,
  getCustomCashbackIconUrl,
} from 'src/store/view/selectors';
import { fetchHotelImagesAction } from 'src/store/hotelImages/sagaActions';
import { isAwaitingFiltration } from '../../domain/state/filters/status_selectors';
import {
  getHotelsList,
  getHotelsCount,
  getAwaitingPagination,
  getFallbackSearch,
  getLiveSearchAllowed,
} from '../../domain/state/hotels/selectors';
import { isMapView } from '../../domain/state/map/selectors';
import { modifierStylesSelector } from '../../domain/state/modifier/selectors';
import { getIsWhitelabel } from '../../domain/state/view/selectors';

import {
  hotelHoverAction,
  showMoreAction,
  setCurrentVisibleHotelsAction,
} from '../../domain/state/hotels/actions';
import { buildUrlAction } from '../../domain/state/mobile/actions';

import { HotelsContainer } from './HotelsContainer';

const mapStateToProps = (state) => ({
  hotels: getHotelsList(state),
  hotelsCount: getHotelsCount(state),
  awaitFiltration: isAwaitingFiltration(state),
  awaitPagination: getAwaitingPagination(state),
  mapExpanded: isMapView(state),
  fallbackSearch: getFallbackSearch(state),
  modifierStyles: modifierStylesSelector(state),
  isWhiteLabel: getIsWhitelabel(state),
  isWebview: getIsWebview(state),
  isHotelOnly: getIsHotelOnly(state),
  currencyCode: getCurrencyCode(state),
  activateCashbackForPartner: getActivateCashbackForPartner(state),
  customCashbackIconURL: getCustomCashbackIconUrl(state),
  customCashbackText: getCashbackLabel(state),
  customCashbackTooltipText: getCashbackTooltip(state),
  isLiveSearchAllowed: getLiveSearchAllowed(state),
});

const mapDispatchToProps = {
  hotelHover: hotelHoverAction,
  buildUrl: buildUrlAction,
  showMore: showMoreAction,
  setCurrentVisibleHotels: setCurrentVisibleHotelsAction,
  getImages: fetchHotelImagesAction,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HotelsContainer);
